
export const iconsMap = {
    'noClouds': {
        'day': `${process.env.PUBLIC_URL}/icons/day-noClouds.png`,
        'night': `${process.env.PUBLIC_URL}/icons/night-noClouds.png`
    },
    'partlyClouds': {
        'day': `${process.env.PUBLIC_URL}/icons/day-partlyClouds.png`,
        'night': `${process.env.PUBLIC_URL}/icons/night-partlyClouds.png`
    },
    'mostlyClouds': {
        'day': `${process.env.PUBLIC_URL}/icons/day-mostlyClouds.png`,
        'night': `${process.env.PUBLIC_URL}/icons/night-mostlyClouds.png`
    },
    'allClouds': {
        'day': `${process.env.PUBLIC_URL}/icons/day-allClouds.png`,
        'night': `${process.env.PUBLIC_URL}/icons/night-allClouds.png`
    },
    'partlyClouds-r2': {
        'day': `${process.env.PUBLIC_URL}/icons/day-partlyClouds-r2.png`,
        'night': `${process.env.PUBLIC_URL}/icons/night-partlyClouds-r2.png`
    },
    'mostlyClouds-r2': {
        'day': `${process.env.PUBLIC_URL}/icons/day-mostlyClouds-r2.png`,
        'night': `${process.env.PUBLIC_URL}/icons/night-mostlyClouds-r2.png`
    },
    'allClouds-r2': {
        'day': `${process.env.PUBLIC_URL}/icons/day-allClouds-r2.png`,
        'night': `${process.env.PUBLIC_URL}/icons/night-allClouds-r2.png`
    },
    'partlyClouds-r3': {
        'day': `${process.env.PUBLIC_URL}/icons/day-partlyClouds-r3.png`,
        'night': `${process.env.PUBLIC_URL}/icons/night-partlyClouds-r3.png`
    },
    'mostlyClouds-r3': {
        'day': `${process.env.PUBLIC_URL}/icons/day-mostlyClouds-r3.png`,
        'night': `${process.env.PUBLIC_URL}/icons/night-mostlyClouds-r3.png`
    },
    'allClouds-r3': {
        'day': `${process.env.PUBLIC_URL}/icons/day-allClouds-r3.png`,
        'night': `${process.env.PUBLIC_URL}/icons/night-allClouds-r3.png`
    }
}   